import React from "react";
import { getLegsToRender, formatDuration, getLegDerivedValues } from "../../utilities/quoteTableExpandedUtils";
import fromIcon from "../../assets/icons/departure-time.svg";
import toIcon from "../../assets/icons/arrival-time.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import timeIcon from "../../assets/icons/time.svg";
import durationIcon from "../../assets/icons/duration.svg";
import fuelStopIcon from "../../assets/icons/fuel-stop-dark.svg";
import infoIcon from "../../assets/icons/info-blue.svg";
import personIconDark from "../../assets/icons/person-dark.svg";
import luggageIcon from "../../assets/icons/luggage-dark.svg";
import Tooltip from "../ui/Tooltip";
import { FUEL_STOP_INFO } from "../../utilities/quoteMessaging";
import ArrivalTime from "../shared/ArrivalTime";

const QuoteTableExpandedTable = ({
    legData,
    maxLegs,
    departureTime,
    arrivalTime,
    duration,
    fuelStop,
    passengers,
    luggage,
    departureAirport,
    arrivalAirport,
}) => {
    const fuelStopTooltipContent = FUEL_STOP_INFO;
    const legsToRender = getLegsToRender(legData, departureAirport, arrivalAirport, passengers, luggage);
    const visibleLegs = typeof maxLegs === "number" && maxLegs > 0 ? legsToRender.slice(0, maxLegs) : legsToRender;

    return (
        <table className="quote-table-expanded-table quote-table-expanded-table--desktop">
            <thead className="quote-table-expanded-table__header">
                <tr>
                    <th className="quote-table-expanded-table__header-cell">
                        <span>
                            <img src={calendarIcon} alt="" />
                            Dep Date
                        </span>
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <span>
                            <img src={timeIcon} alt="" />
                            Dep Time
                        </span>
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <span>
                            <img src={fromIcon} alt="" />
                            From
                        </span>
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <span>
                            <img src={durationIcon} alt="" />
                            Duration
                        </span>
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <span>
                            <img src={toIcon} alt="" />
                            To
                        </span>
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <span>
                            <img src={timeIcon} alt="" />
                            Arr Time
                        </span>
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <img src={personIconDark} alt="" className="quote-table-expanded-table__header-icon" />
                    </th>
                    <th className="quote-table-expanded-table__header-cell">
                        <img src={luggageIcon} alt="" className="quote-table-expanded-table__header-icon" />
                    </th>
                </tr>
            </thead>
            <tbody className="quote-table-expanded-table__body">
                {visibleLegs.length > 0 ? (
                    visibleLegs.map((leg, index) => {
                        const {
                            formattedDepartureDate,
                            departureTimeFormatted,
                            arrivalTimeFormatted,
                            legDepartureDate,
                            legArrivalDate,
                            legFuelStop,
                            legDuration,
                        } = getLegDerivedValues(leg, index, {
                            departureTime,
                            arrivalTime,
                            duration,
                            fuelStop,
                        });
                        return (
                            <tr key={index} className="quote-table-expanded-table__row">
                                <td className="quote-table-expanded-table__cell">{formattedDepartureDate}</td>
                                <td className="quote-table-expanded-table__cell">{departureTimeFormatted}</td>
                                <td className="quote-table-expanded-table__cell quote-table-expanded-table__cell--location">
                                    <span>{leg.departureAirport?.longName || "-"}</span>
                                </td>
                                <td className="quote-table-expanded-table__cell quote-table-expanded-table__cell--duration">
                                    {legFuelStop > 0 ? (
                                        <>
                                            <img
                                                className="quote-table-expanded-table__fuel-stop-icon"
                                                src={fuelStopIcon}
                                                alt=""
                                            />
                                            <span className="quote-table-expanded-table__fuel-stop-time">
                                                {formatDuration(legDuration)}
                                            </span>
                                            <br />
                                            <span className="quote-table-expanded-table__fuel-stop-meta">
                                                <span className="quote-table-expanded-table__fuel-stop-text">
                                                    {legFuelStop === 1 ? "Fuel stop" : `${legFuelStop} Fuel stops`}
                                                </span>
                                                <Tooltip content={fuelStopTooltipContent}>
                                                    <img
                                                        className="quote-table-expanded-table__fuel-stop-info-icon"
                                                        src={infoIcon}
                                                        alt="Fuel stop information"
                                                    />
                                                </Tooltip>
                                            </span>
                                        </>
                                    ) : (
                                        formatDuration(legDuration)
                                    )}
                                </td>
                                <td className="quote-table-expanded-table__cell quote-table-expanded-table__cell--location">
                                    <span>{leg.arrivalAirport?.longName || "-"}</span>
                                </td>
                                <td className="quote-table-expanded-table__cell">
                                    {arrivalTimeFormatted === "-" ? (
                                        "-"
                                    ) : (
                                        <ArrivalTime
                                            time={arrivalTimeFormatted}
                                            departureDate={legDepartureDate}
                                            arrivalDate={legArrivalDate}
                                        />
                                    )}
                                </td>
                                <td className="quote-table-expanded-table__cell">
                                    {leg.passengers || passengers || "-"}
                                </td>
                                <td className="quote-table-expanded-table__cell">
                                    {leg.luggage !== undefined && leg.luggage !== null ? leg.luggage : "-"}
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr className="quote-table-expanded-table__row">
                        <td
                            colSpan="8"
                            className="quote-table-expanded-table__cell"
                            style={{ textAlign: "center", padding: "20px" }}
                        >
                            No flight schedule data available
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default QuoteTableExpandedTable;
